// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"21":"e6a4bafb","46":"5e88aee1","232":"59ea6404","450":"209ffbd6","635":"aefba64e","660":"42b77298","921":"853e3087","977":"31147f21"}[chunkId] + ".chunk.css";
};